// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu--qOY62","action":"action--1fXjX","account":"account--3e8Hr","avatar":"avatar--1A5A5"};